import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Mail, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export const EmailConfirmationBanner: React.FC = () => {
  const { user, isEmailConfirmed } = useAuth();
  const [isResending, setIsResending] = useState(false);

  const handleResendConfirmation = async () => {
    if (!user?.email) return;
    
    setIsResending(true);
    try {
      const { error } = await supabase.functions.invoke('resend-confirmation', {
        body: { email: user.email }
      });

      if (error) {
        toast.error('Fehler beim Senden der Bestätigungs-E-Mail');
      } else {
        toast.success('Bestätigungs-E-Mail wurde erneut gesendet');
      }
    } catch (error) {
      toast.error('Fehler beim Senden der Bestätigungs-E-Mail');
    } finally {
      setIsResending(false);
    }
  };

  if (!user || isEmailConfirmed) {
    return null;
  }

  return (
    <Alert className="border-warning bg-warning/10 mb-4">
      <AlertTriangle className="h-4 w-4 text-warning" />
      <AlertDescription className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          <Mail className="h-4 w-4" />
          <span>
            Bitte bestätige deine E-Mail-Adresse, um alle Funktionen nutzen zu können.
          </span>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleResendConfirmation}
          disabled={isResending}
        >
          {isResending ? 'Wird gesendet...' : 'E-Mail erneut senden'}
        </Button>
      </AlertDescription>
    </Alert>
  );
};